<template>
  <div class="main">
    
  

<div style="background-color:#e5e5e5;padding:15px;text-align:center; border-radius: 5px">
  <h1>Avcom Manufacturing > Home</h1>
  <h3>For Manufacturing and Supplying Baking Ingredients</h3>
</div>

<div style="overflow:auto">
  <div class="menu">
  <router-link to = "/" class = "main-links" style ="  text-decoration: none;  "> Home</router-link>
    <router-link to = "/AboutUs" class = "main-links" style ="  text-decoration: none;  ">About Us</router-link>
    <router-link to = "/BakingIngredients" class = "main-links" style ="  text-decoration: none;  ">Our Baking Ingredients</router-link>
    <router-link to = "/ContactUs" class = "main-links" style ="  text-decoration: none;  ">Contact Us</router-link>
      <router-link to = "/New" class = "main-links" style ="  text-decoration: none;  ">Our new page</router-link>
  </div>

  <div class="controller">
  <div class="baking-ingredients-images">  

  <img class = "photo" src ="../assets/baking-ingredients1.jpeg" height = "600px"/>
   <img class = "photo" src ="../assets/baking-ingredients2.jpeg" height = "300px"/>
   <img class = "photo" src ="../assets/baking-ingredients3.jpeg" height = "300px"/>
   <img class = "photo" src ="../assets/baking-ingredients4.jpeg" height = "600px"/>
  </div>
  </div>

  <div class="right">
    <h2>Our Promise</h2>
    <p>At Avcom we know the value of quality ingredients and we leave no stone unturned as we strive to make your baking a pleasurous experience.</p>
    <p> We know that each baking moment is a meorable moment and we don't want you to get dissapointed. So if baking is your source of joy and nourishment then you have visited the right place.</p>
    <p>Delicous food is one good source of family joy. By choosing us, you are just making sure that every family encounter with a meal is a special ocaasion to all. Please enjoy....</p>
  </div>
</div>
<footer>
    <div style="background-color:#e5e5e5;text-align:center;padding:10px;margin-top:7px;">
        <p>OUR PHYSICAL ADDRESSES:</p>
        <p>92 Cameroon Street </p>
        <p>Harare </p>
        <p>White House Building First Floor </p>
        <p>Shop Number 10</p>
        <hr/>
       <p> 1557 Dzivarasekwa Extension</p>
       <p> Dzivarasekwa</p>
       <p> Harare</p>
       <h3> FOR WHATSAPP CHAT CLICK ANY ONE ICON BELOW:   </h3>
        <P><a href="https://api.whatsapp.com/send/?phone=%2B263719327994&text&app_absent=0"><img src ="../assets/whatsapp.png" width ="80px"/></a></P>
        <p>OR</p>
        
            <p><a href="https://api.whatsapp.com/send/?phone=%2B263777327994&text&app_absent=0"><img src ="../assets/whatsapp.png" width ="80px"/></a></P>
        <br/>
                <h3> FOLLOW US ON OUR FACEBOOK PAGE   </h3>
                        <br/>

        <a href="https://www.facebook.com/Avcom-manufacturing-pvt-ltd-101934582241773/"><img src="../assets/facebook.png" width="80"></a>         


    </div>
    <hr/>
<div style="background-color:#e5e5e5;text-align:center;padding:10px;margin-top:7px;margin-bottom: 10px">&copy; LearAdlib.com 2021</div>
</footer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

* {
  box-sizing: border-box;
}

.menu {
  float: left;
  width: 20%;
  text-align: center;
}
.main-links:hover{

background-color: black;
color:white;
}

.menu a {
  background-color: #e5e5e5;
  padding: 8px;
  margin-top: 7px;
  display: block;
  width: 100%;
  color: black;
}

.main {
 
  background-image: linear-gradient(olivedrab, purple);
  width: 100%;
  padding-bottom: 10px;
  padding-top: 5px;
  padding-left: 2px;
  padding-right: 2px
}

.right {
  background-color: #e5e5e5;
  float: left;
  width: 20%;
  padding: 15px;
  margin-top: 7px;
  text-align: center;
}

@media only screen and (max-width: 620px) {
  /* For mobile phones: */
  .menu, .main, .right {
    width: 100%;
  }
}
.controller{
 float: left;
  margin: 50px auto;
  width: 60%;
  height: 500px;
  overflow: hidden;
  border: 2px solid;
  border-radius: 15px;
  border-top-color: #856036;
  border-left-color: #5d4426;
  border-bottom-color: #856036;
  border-right-color: #5d4426;
  position: relative;
   display: flex;
  justify-content: center;
   background-color: #e5e5e5;
    
}
.baking-ingredients-images {
    float: left;
  margin: 50px auto;
  width: 400px;
  height: 400px;
  overflow: hidden;
  border: 2px solid;
  border-radius: 10px;
  border-top-color: #856036;
  border-left-color: #5d4426;
  border-bottom-color: #856036;
  border-right-color: #5d4426;
  position: relative;
   display: flex;
  justify-content: center;

}

.photo {
  position: absolute;
  animation: round 16s infinite;
  opacity: 0;
}

@keyframes round {
  25% {
    opacity: 1;
  }
  40% {
    opacity: 0;
  }
}
img:nth-child(1) {
  animation-delay: 12s;
}

img:nth-child(2) {
  animation-delay: 8s;
}

img:nth-child(3) {
  animation-delay: 4s;
}
</style>

